import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { IconButton, TableCell, TableRow, Tooltip, Button } from '@mui/material';
import { toast } from 'react-toastify';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ModalContainer from '../components/containers/ModalContainer';
import env from '../config/env';
import { Link } from 'react-router-dom';
import api from '../config/axios';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import StatusComp from '../components/common/StatusComp';

const InternationalLabelPricing = () => {
    const [pricings, setPricings] = useState([]);
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');
    const [lableTypeSwift, setlableTypeSwift] = useState('');
    const [lableName, setlableName] = useState('');
    const [single, setSingle] = useState({});

    const [showAddLabel, setShowAddLabel] = useState(false);

    const onCloseAddLabelModal = () => {
        setShowAddLabel(false);
    };
    const onOpenAddLabelModal = () => setShowAddLabel(true);

    const [showEditLabel, setShowEditLabel] = useState(false);

    const onCloseEditLabelModal = () => {
        setShowEditLabel(false);
    };
    const onOpenEditLabelModal = () => setShowEditLabel(true);

    const [showDeleteLabel, setShowDeleteLabel] = useState(false);

    const onCloseDeleteLabelModal = () => {
        setShowDeleteLabel(false);
    };
    const onOpenDeleteLabelModal = () => setShowDeleteLabel(true);

    const getPricings = async () => {
        await api
            .get('/international-labeltype/read')
            .then((res) => {
                setPricings(res.data.labelTypes);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getPricings();
    }, []);

    const addPricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            name: e.target.name.value,
            maxWeight: e.target.maxWeight.value,
        };

        await api
            .post('/international-labeltype/create', data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseAddLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const updatePricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            name: single.name,
            maxWeight: single.maxWeight,
        };

        await api
            .post('/international-labeltype/update/' + single._id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseEditLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const enableDisableLabelType = async (id) => {
        await api
            .put('/international-labeltype/enableDisableLabelType/' + id, {})
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const DeleteLabelType = async (id) => {
        await api
            .delete('/international-labeltype/delete/' + id)
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
                onCloseDeleteLabelModal();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    return (
        <PageContainer
            title="International Label Pricing"
            desc="Set and manage international label pricing"
            end={
                <Button onClick={onOpenAddLabelModal} variant="contained">
                    Add Label Type
                </Button>
            }>
            <CustomTable sx={{ mt: 2 }} fields={['#', 'NAME', 'MAXWEIGHT', 'STATUS', 'ACTION']} dense={false}>
                {pricings.map((pricing, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{pricing.name}</TableCell>
                        <TableCell>{pricing.maxWeight}</TableCell>
                        <TableCell>
                            <StatusComp status={pricing.status ? 'active' : 'inactive'} />
                        </TableCell>

                        <TableCell>
                            <Link to={'/labelPricing-international/' + pricing._id}>
                                <Tooltip title="Manage Pricing">
                                    <IconButton>
                                        <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenEditLabelModal();
                                }}
                                title="Edit">
                                <ModeEditOutlineOutlinedIcon fontSize="small" />
                            </IconButton>
                            {pricing.status ? (
                                <Tooltip title="Disable">
                                    <IconButton onClick={() => enableDisableLabelType(pricing._id)}>
                                        <CloseOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <Tooltip title="Enable">
                                    <IconButton onClick={() => enableDisableLabelType(pricing._id)}>
                                        <CheckOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenDeleteLabelModal();
                                }}>
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* create modal */}

            <ModalContainer open={showAddLabel} onClose={onCloseAddLabelModal} hideActions title="Add Label Type">
                {message}
                <form onSubmit={addPricing}>
                    <div className="form-group mb-3">
                        <label>Name</label>
                        <input type="text" className="form-control form-control-sm" name="name" required />
                    </div>

                    <div className="form-group mb-3">
                        <label>Max Weight</label>
                        <input type="number" className="form-control form-control-sm" name="maxWeight" required />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseAddLabelModal()}
                            s>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Add {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* edit modal */}

            <ModalContainer hideActions open={showEditLabel} onClose={onCloseEditLabelModal} title="Edit Label Type">
                {message}
                <form onSubmit={updatePricing}>
                    <div className="form-group mb-3">
                        <label>Name</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="name"
                            required
                            value={single.name}
                            onChange={(e) => setSingle({ ...single, name: e.target.value })}
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Max Weight</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="maxWeight"
                            required
                            value={single.maxWeight}
                            onChange={(e) => setSingle({ ...single, maxWeight: e.target.value })}
                        />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseEditLabelModal()}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Update {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* delete label */}
            <ModalContainer
                hideActions
                open={showDeleteLabel}
                onClose={onCloseDeleteLabelModal}
                title="Delete Label Type">
                {message}
                <div className="text-center mt-0">
                    <p>Are you sure want to delete this label?</p>
                </div>

                <div className="d-flex justify-content-between ">
                    <button type="button" className="btn btn-default" onClick={() => onCloseDeleteLabelModal()}>
                        Close
                    </button>
                    <button className="btn btn-danger" onClick={() => DeleteLabelType(single._id)}>
                        Delete {loader}
                    </button>
                </div>
            </ModalContainer>
        </PageContainer>
    );
};

export default InternationalLabelPricing;
